import { BANDS, fint } from "@/lib/ui";

export const Chip = ({ b }) => b ? <span className={`chip ${b}`}>{b}</span> : <span className="chip none">No score</span>;

export const Select = ({ id, label, opts, sel, allLabel = "All", onChange }) => (
  <div className="fld">
    <label htmlFor={id}>{label}</label>
    <select id={id} data-testid={id} value={sel} onChange={e => onChange(e.target.value)}>
      {allLabel !== null ? <option value="">{allLabel}</option> : null}
      {opts.map(o => Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>)}
    </select>
  </div>
);

export const Legend = () => (
  <div className="legend" aria-label="Score bands">
    {BANDS.map(([b, r]) => <span key={b} className={`chip ${b}`}>{b} <span className="rng">{r}</span></span>)}
  </div>
);

export const ToolTag = ({ t }) => t ? <span className={`tool-tag t-${String(t).toLowerCase()}`}>{t}</span> : "—";

export function Likert({ r }) {
  const t = (r.v5 || 0) + (r.v4 || 0) + (r.v3 || 0) + (r.v2 || 0) + (r.v1 || 0);
  if (!t) return <span className="muted">—</span>;
  const seg = (k, c) => r[k] ? <i style={{ width: `${(r[k] / t) * 100}%`, background: `var(${c})` }}></i> : null;
  const tip = `Rated 5: <span class='num'>${fint(r.v5)}</span> · 4: <span class='num'>${fint(r.v4)}</span> · 3: <span class='num'>${fint(r.v3)}</span> · 2: <span class='num'>${fint(r.v2)}</span> · 1: <span class='num'>${fint(r.v1)}</span>`;
  return <div className="lk" data-tip={tip}>{seg("v5", "--lk5")}{seg("v4", "--lk4")}{seg("v3", "--lk3")}{seg("v2", "--lk2")}{seg("v1", "--lk1")}</div>;
}
